module.exports = __webpack_public_path__ + "static/img/休眠.6d7364f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/叉车/休眠.png
// module id = 9nPo
// module chunks = 76